import * as React from 'react';

import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';
import { Bar, SkeletonStack } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { IdShape, StatusShape, TitleShape } from './ProposalListLoading.styled';
import {
    Container,
    Header,
    SummaryBlock,
    SummaryColumn,
    SummaryTitle,
    SummaryValue,
    Text,
} from './ProposalPreview.layout';

const ProposalListLoading = () => (
    <ContentPlaceholder label="Loading proposals">
        {Array.from({ length: 3 }, (_, index) => (
            <Container key={index} aria-hidden="true">
                <Header>
                    <IdShape $width="4rem" $height="2.4rem" />
                    <TitleShape $width="28rem" $height="2.8rem" />
                    <StatusShape $width="9rem" $height="2.4rem" />
                </Header>
                <Text as="div">
                    <SkeletonStack $gap="0.8rem">
                        <Bar $width="100%" />
                        <Bar $width="95%" />
                        <Bar $width="72%" />
                    </SkeletonStack>
                </Text>
                <SummaryBlock>
                    {Array.from({ length: 3 }, (_, i) => (
                        <SummaryColumn key={i}>
                            <SummaryTitle>
                                <Bar $width="9rem" $height="1.6rem" />
                            </SummaryTitle>
                            <SummaryValue>
                                <Bar $width="12rem" $height="2.4rem" />
                            </SummaryValue>
                        </SummaryColumn>
                    ))}
                </SummaryBlock>
            </Container>
        ))}
    </ContentPlaceholder>
);

export default ProposalListLoading;
